import styled from 'styled-components';

export const ForgotPasswordContent = styled.div`
  display: flex;
  justify-content: end;
  padding: 3px ${({ theme }): string => theme.spacers!.spacer02};
  margin-bottom: ${({ theme }): string => theme.spacers!.spacer04};
  font-family: InspireTWDC;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  color: ${({ theme }): string => theme.admanColors!.blue.dark.bg1[0]};
`;
